module.exports = __webpack_public_path__ + "static/media/psychological-health.a6092485.webp";